<avatar-list (selectionChanged)="onSelectUser($event)" [type]="'user'"
             [enabled]="true"
             [availableElements]="_users" [placeholder]="'Users'"></avatar-list>